import { Utilities, ModalAction } from "./Utilities";

// Enum
export interface IModalPromptRequest {
    title?: string;
    body?: string;
    yesBtn?: string;
    noBtn?: string;
    extraBtn?: string;
    promptYesNoPredefinedEnum?: PredefinedModalEnum;
    data?: any;
}

export interface IModalPromptResult {
    success: Boolean;
    yes?: Boolean;
    no?: Boolean;
    extraBtn?: Boolean;
    message?: String;
    data?: any;
}

export enum PredefinedModalEnum {
    None,
    UnsavedEdits,
    SaveFirstAndPrompt,
    Delete,
    RecordListReport,
    Annotation_CreateNewGroup,
    SubmissionsAccept,
    SubmissionsSave,
    SubmissionsDeleteIssue,
    ContactsDeleteCloudscribeUser,
    ContactsDeleteCAMSUser,
    InfraCondition_CreateIssue,
    InfraDeleteAndArchive,
    InfraOverwriteReplacementCost,
    InfraMakeHistoric,
    MaintRejectIssue,
    NotificationQuery,
    TaskAcceptWarning,
    TaskCompleteAllInGroup,
    TasksCreateGroup,
    GeomRedraw,
    LegalPublishToRegister
}

export enum jqc {
    placeholder_for_promptModals = '#placeholder-for-promptModals',
    promptYesNoModal = '#promptYesNoModal',
    promptModalYesBtn = '#promptModalYesBtn',
    promptModalNoBtn = '#promptModalNoBtn',
    promptModalExtraBtn = '#promptModalExtraBtn'

}

export class ModalPrompts {

    // ----------------------------------------------------------- //
    // OPEN PROMPT
    static OpenPrompt = (promptData: IModalPromptRequest): Promise<IModalPromptResult> => {
        return new Promise<IModalPromptResult>((resolve, reject) => {
            try {
                Utilities.GetControl(jqc.placeholder_for_promptModals).load(window.G_SITEFOLDERNAME +'/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
                    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
                    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) {
                        evt.preventDefault();
                        Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide);
                        resolve({ success: true, yes: true });
                    });
                    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) {
                        evt.preventDefault();
                        Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide);
                        resolve({ success: true, no: true });
                    });

                    Utilities.GetControl(jqc.promptModalExtraBtn).on('click', function (evt) {
                        evt.preventDefault();
                        Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide);
                        resolve({ success: true, extraBtn: true });
                    });
                });
            }
            catch (e) {
                reject({ success: false });
            }
        });
    }
}






